import React from "react";
import {
  AiFillGoogleCircle,
  AiOutlineWhatsApp,
  AiFillYoutube,
  AiFillInstagram,
} from "react-icons/ai";


const Footer = () => {
  return (
    <footer>
        <p>Copyright © 2023 Kather | All Rights Reserved</p>
        <ul>
          <li>
            <a
              href="https://chat.whatsapp.com/HrjTlXYc0VlLXhKiZn9U58"
              target="blank"
            >
              <AiOutlineWhatsApp class="icon" style={{ color: "white" }} />
            </a>
          </li>
          <li>
            <a href="/" target="blank">
              <AiFillGoogleCircle class="icon" style={{ color: "white" }} />
            </a>
          </li>

          <li>
            <a href="">
              <AiFillYoutube class="icon" style={{ color: "white" }} />
            </a>
          </li>
          <li>
            <a
              href="https://instagram.com/kather.kath?igshid=YmMyMTA2M2Y="
              target="blank"
            >
              <AiFillInstagram class="icon" style={{ color: "white"}} />
            </a>
          </li>
        </ul>
    </footer>
  );
};

export default Footer;
